<div class="mt-56px">
    <div class="custella-form-container left-right-space rounded-2">
        <div class="custella-form-container-title" id="title_GlobalRequisitionDet" *ngIf="parentType == 'requisition'">{{translate?.requisition.sections.sec10.singular}}</div>
        <div class="custella-form-container-title" id="title_GlobalConsignmentDet"  *ngIf="parentType == 'consignment'">{{translate?.consignment.sections.sec7.singular}}</div>
        <!-- STEP 0; 3 OPTIONS -->
        <div class="custella-form-container-content">
            <h5 class="font-medium text-center" *ngIf="parentType == 'requisition'">{{translate?.requisition.messages.whatWouldYouLikeRequest}}</h5>
            <h5 class="font-medium text-center" *ngIf="parentType == 'consignment'">{{translate?.consignment.messages.whatWouldYouLikeSend}}</h5>
            <div class="form-options-two mt-4">
                <div class="items-sm"  (click)="onSelectTypeChange('asset')">
                    <h6><i class="fa-regular fa-box fa-xl"></i>{{translate?.asset.label.plural}}</h6>
                </div>
                <div class="items-sm" (click)="onSelectTypeChange('sparePart')">
                    <h6><i class="fa-regular fa-gears fa-xl"></i>{{translate?.product.label.plural}}</h6>
                </div>
                <div class="items-sm" (click)="onSelectTypeChange('custom')">
                    <h6>{{translate?.requisition.sections.sec11.singular}}</h6>
                    <span class="desc">
                        <span class="text-center" *ngIf="parentType == 'requisition'">{{translate?.requisition.messages.defineCustomListOfItems}}</span>
                        <span class="text-center" *ngIf="parentType == 'consignment'">{{translate?.consignment.messages.defineCustomListOfItems}}</span>
                    </span>
                </div>
            </div>
        </div>
        
        <div class="custella-form-container-footer">
            <div class="d-flex align-items-center justify-content-end">
                <button class="custella-btn-white text-12 ms-2" (click)="goBack()">{{translate?.general.buttons.cancel.singular}}</button>
                </div>
        </div>
    </div>
</div>